// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"298":"ebb18bc7","370":"2b947e82","445":"244fea2c","453":"68693753","476":"d7b15a6b","513":"49878868","787":"24a16a94"}[chunkId] + ".chunk.js";
};